import React, { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import {
  AiOutlineCopy,
  AiOutlineLike,
  AiOutlineDislike,
  AiFillLike,
  AiFillDislike,
  AiOutlineClose,
} from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { HiMiniClipboardDocumentCheck } from "react-icons/hi2";
import { VscSend } from "react-icons/vsc";
import { FiSidebar } from "react-icons/fi";
import Okation from "../../../../Assets/boxMind_wide.png";
import Turbo from "../../../../Assets/boxMind_wide.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom";
import ChatHistory from "./History/ChatHistory";
import DeleteAllRooms from "../Chat/History/DeleteAllRooms";
import { CiStop1 } from "react-icons/ci";
import api from "../../../api";
import { AsyncImage } from "loadable-image";
import { Blur } from "transitions-kit";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { GoImage } from "react-icons/go";
import { MdOutlineCancel, MdVolumeOff, MdVolumeUp } from "react-icons/md";
import Logo from "../../../../Assets/OkationLogo.png";
import ChatUser from "../../../../Assets/ChatPerson.png";
import Agent from "./Agent";
import Tag from "./Tag";
import { RiMicLine } from "react-icons/ri";
import ReactMarkdown from "react-markdown";
import ReactAudioPlayer from "react-audio-player";
import { v4 as uuidv4 } from "uuid";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkMath from "remark-math";
import rehypeMathJax from "rehype-mathjax";
import remarkGfm from "remark-gfm";
import styles from "../../../../ChatStyles.module.css";
import Cookies from "js-cookie";

let currentInputVar = 0;
let currentCodeInputVar = 0;
let currentImgInputVar = 0;
let firsttoken = 0;
let lastgeneratingcode = 0;
let newChatRefresh = 0;
let imageBase64Data = "";
let currentImageInputVar = 0;
let printcode = false;
let printgeneratecode = false;
let printimage = false;

interface Message {
  type: "input" | "response" | "clipboard" | "audio";
  message: JSX.Element | string;
  image?: string;
  audio?: string;
  audioId?: string;
}

interface History {
  chat_details_id: string;
  room_id: number;
  question: string;
  answer: string;
  error: string;
  response_time: string;
  pdf_name: string;
  like: string;
  dislike: string;
  is_regenerated: string;
  user_comments: string;
  question_date_time: string;
  faithfulness: string;
  answer_relevancy: string;
  context_relevancy: string;
  debug: number;
  sources: string;
  image: string;
}

const Thinking = [
  "Searching...",
  "Fetching the data...",
  "Generating response...",
];

const examples: string[] = [
  "Why do I need to learn GenAI?",
  "How can I improve my grades?",
  "What are the best study habits?",
  "How do I handle stress and anxiety related to school?",
  "What should I major in or what career should I pursue?",
  "How do I balance school with other activities?",
];

const employeeExamples: string[] = [
  "What is Artificial Intelligence?",
  "Will AI take over my job or just make it easier?",
  "What is the difference between AI and Generative AI?",
  "How can I write better prompts to get good answers from AI?",
  "What skills should I learn to work effectively with AI systems?",
  "Is it safe to share company data with AI tools like ChatGPT?",
];

function NewChat({ userData, sideActive, mainSidebarOpen }: any) {
  const [messageList, setMessageList] = useState<Message[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [inputMessage, setInputMessage] = useState<string>("");

  const clientId = localStorage.getItem("user_id");
  const user_name = userData?.user_name ?? "";

  const [selectedRoomId, setSelectedRoomId] = useState<number>(
    Math.round(Math.random() * 1e9)
  );

  //visibility
  const [sidebarVisible, setSidebarVisible] = useState<boolean>(true);
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  const [moreOptions, setMoreOptions] = useState<boolean>(false);

  //References
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [responseStarted, setResponseStarted] = useState<boolean>(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [previousQuestion, setPreviousQuestion] = useState<string>("");

  const [refreshRooms, setRefreshRooms] = useState(0);

  //History Chat
  const [historyData, setHistoryData] = useState<History[]>([]);

  //Image
  const [expandedImage, setExpandedImage] = useState(null);

  //Exel
  const [file, setFile] = useState<File | null>(null);

  //Agent
  const [selectedAgent, setSelectedAgent] = useState<string>("");
  const [selectedAgentId, setSelectedAgentId] = useState<string | "">("");
  const [agentActive, setAgentActive] = useState<boolean>(false);

  //tag
  const [tagActive, setTagActive] = useState<boolean>(false);
  const [selectedTag, setSelectedTag] = useState("");
  const [selectedTagName, setSelectedTagName] = useState("");

  const [isScrolledUp, setIsScrolledUp] = useState<boolean>(false);
  const [shuffledExamples, setShuffledExamples] = useState<string[]>([]);
  const [openDeleteAll, setOpenDeleteAll] = useState(false);

  const user_id = localStorage.getItem("user_id") || "default_user";

  const [isRecording, setIsRecording] = useState<boolean>(false);
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [audioChunks, setAudioChunks] = useState<Blob[]>([]);

  const [useTTs, setUseTTs] = useState<boolean>(false);
  const [audioElements, setAudioElements] = useState<{
    [key: string]: HTMLAudioElement;
  }>({});

  const toggleTTS = () => {
    setUseTTs((prevState) => !prevState);
  };

  const handleRecording = async () => {
    if (!isRecording) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
          });

          const recorder = new MediaRecorder(stream, {
            mimeType: "audio/webm",
          });

          setAudioChunks([]);

          recorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
              setAudioChunks((prev) => [...prev, e.data]);
            } else {
              console.log("No data received from ondataavailable");
            }
          };

          recorder.start(1000);
          setMediaRecorder(recorder);
          setIsRecording(true);
        } catch (error) {
          toast.error("Could not access microphone.", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            theme: "dark",
          });
        }
      } else {
        toast.error("Audio recording is not supported in this browser.", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          theme: "dark",
        });
      }
    } else {
      if (mediaRecorder) {
        mediaRecorder.stop();
        setIsRecording(false);

        mediaRecorder.onstop = async () => {
          if (audioChunks.length > 0) {
            const audioBlob = new Blob(audioChunks, { type: "audio/webm" });

            const audioContext = new window.AudioContext();

            try {
              const arrayBuffer = await audioBlob.arrayBuffer();

              const audioBuffer = await audioContext.decodeAudioData(
                arrayBuffer
              );

              const duration = audioBuffer.duration;

              const formData = new FormData();
              formData.append("audio_file", audioBlob);
              formData.append("audio_duration", duration.toString());

              try {
                const response = await api.post(
                  `${process.env.REACT_APP_VOICE}`,
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );

                const responseData = response.data.transcription;
                setInputMessage(responseData || "");
              } catch (error: any) {
                toast.error(error.response.data.message, {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: false,
                  theme: "dark",
                });
              }
            } catch (error: any) {
              console.error("Error decoding audio data:", error);
              toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "dark",
              });
            }
          } else {
            toast.error("No audio was recorded.", {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              theme: "dark",
            });
          }
          setAudioChunks([]);
        };
      }
    }
  };

  const handleImageClick = (image: any) => {
    setExpandedImage(image);
  };

  const handleCloseModal = () => {
    setExpandedImage(null);
  };

  const showMenu = () => {
    setMenuVisible(!menuVisible);
  };
  const toggleSidebar = () => {
    setSidebarVisible((prevVisible) => !prevVisible);
  };

  useEffect(() => {
    if (!sidebarVisible) {
      setMoreOptions(false);
    }
  }, [sidebarVisible]);

  const showAgent = () => {
    setAgentActive(!agentActive);
  };

  const showTag = () => {
    setTagActive(!tagActive);
  };

  const refreshChatHistory = async (selectedRoomId: string) => {
    const apiUrl = `${process.env.REACT_APP_INTERFACE_HISTORY}${selectedRoomId}`;
    try {
      const response = await api.get(apiUrl);

      const data = response.data;

      setHistoryData(data);
      setInputMessage("");
      setMessageList([]);

      currentInputVar = data.length - 1;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedRoomId) {
      refreshChatHistory(selectedRoomId.toString());
    }
  }, [selectedRoomId]);

  const token = Cookies.get("access_token");

  //Recieve Answer
  useEffect(() => {
    const socket = io(`${process.env.REACT_APP_QUESTIONS}`, {
      path: "/socket.io",
      auth: {
        token: token,
      },
    });

    socket.on("connect", () => {
      socket.emit("join", { room_id: selectedRoomId });
    });
    socket.on("token", (token: { data: string }) => {
      setResponseStarted(false);
      if (token.data === "end_stream") {
        return;
      }

      const responseMessage: Message = {
        type: "response",
        message: token.data,
      };

      if (token.data === "start_generate_code") {
        printgeneratecode = true;
        currentCodeInputVar++;

        var housebox = document.getElementById(`text-wrap-${currentInputVar}`);

        const generatingcode = document.createElement("div");
        generatingcode.setAttribute(
          "id",
          `code-generating-button-div-${currentCodeInputVar}`
        );
        generatingcode.setAttribute("number", currentCodeInputVar.toString());
        lastgeneratingcode = currentCodeInputVar;
        generatingcode.classList.add("generating-code");
        generatingcode.onclick = function () {
          showHide(currentCodeInputVar);
        };

        const textSpan =
          '<span style="display: inline-block; vertical-align: middle; margin-right: 5px;">GENERATING CODE</span>';
        const arrowSVG =
          '<span style="display: inline-block; vertical-align: middle;"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 8.295 12 12.875l4.59-4.58L18 9.705l-6 6-6-6z"></path></svg></span>';

        generatingcode.innerHTML = textSpan + arrowSVG;

        housebox?.appendChild(generatingcode);

        const parentbox = document.createElement("div");
        parentbox.classList.add("parentcodeboxstyle");
        parentbox.setAttribute("id", `parent-code-div-${currentCodeInputVar}`);
        parentbox.style.display = "none";
        housebox?.appendChild(parentbox);

        firsttoken = 1;
      } else if (token.data === "end_generate_code") {
        var generatedcode = document.getElementById(
          `code-generating-button-div-${currentCodeInputVar}`
        );
        if (generatedcode) {
          generatedcode.innerHTML =
            '<span style="display: inline-block; vertical-align: middle; margin-right: 5px;">CODE GENERATED</span>' +
            '<span style="display: inline-block; vertical-align: middle;"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 8.295 12 12.875l4.59-4.58L18 9.705l-6 6-6-6z"></path></svg></span>';
          generatedcode.classList.remove("generating-code");
          generatedcode.classList.add("generated-code");
        }
        printgeneratecode = false;
      } else if (token.data === "start_code") {
        printcode = true;
        currentCodeInputVar++;
        var housebox = document.getElementById(`text-wrap-${currentInputVar}`);

        const parentbox = document.createElement("div");
        parentbox.classList.add("parentcodeboxstyle");
        parentbox.setAttribute("id", `parent-code-div-${currentCodeInputVar}`);

        // Create title div for code block
        const titleDiv = document.createElement("div");
        titleDiv.classList.add("titlestyle");

        // Create code content div
        const codeContent = document.createElement("div");
        codeContent.classList.add("codeboxstyle");
        codeContent.setAttribute("id", `code-content-${currentCodeInputVar}`);

        parentbox.appendChild(titleDiv);
        parentbox.appendChild(codeContent);
        housebox?.appendChild(parentbox);
      } else if (token.data === "start_image") {
        // Handle start of image
        printimage = true;
        currentImageInputVar++;
        var housebox = document.getElementById(`text-wrap-${currentInputVar}`);

        const imageContainer = document.createElement("div");
        imageContainer.classList.add("image-container");
        imageContainer.setAttribute(
          "id",
          `image-container-${currentImageInputVar}`
        );
        housebox?.appendChild(imageContainer);

        imageBase64Data = "";
      } else if (token.data === "end_image") {
        printimage = false;
        var imageContainer = document.getElementById(
          `image-container-${currentImageInputVar}`
        );

        if (imageContainer && imageBase64Data) {
          const img = document.createElement("img");
          img.src = `data:image/png;base64,${imageBase64Data}`;
          img.classList.add("generated-image");
          imageContainer.appendChild(img);
        }
      } else if (printimage) {
        imageBase64Data += token.data;
      } else if (token.data === "end_code") {
        printcode = false;

        var codeBox = document.getElementById(
          `parent-code-div-${currentCodeInputVar}`
        );
        if (codeBox) {
          const titleDiv = codeBox.querySelector(".titlestyle");
          if (titleDiv) {
            const copyButton = document.createElement("button");
            copyButton.classList.add("copy-button");
            copyButton.textContent = "Copy";
            copyButton.onclick = () =>
              copyButtonHistory(currentCodeInputVar, currentInputVar);
            titleDiv.appendChild(copyButton);
          }

          const codeContent = codeBox.querySelector(".codeboxstyle");
          if (codeContent) {
            const codeText = codeContent.textContent || "";
            const lines = codeText.split("\n");
            const title = lines.shift() || "javascript";
            const codeWithoutTitle = lines.join("\n");

            ReactDOM.render(
              <SyntaxHighlighter language={title.toLowerCase()} style={dracula}>
                {codeWithoutTitle}
              </SyntaxHighlighter>,
              codeContent
            );
          }
        }
      } else if (printcode) {
        var codeBox = document.getElementById(
          `code-content-${currentCodeInputVar}`
        );
        if (codeBox) {
          const existingContent = codeBox.textContent || "";
          codeBox.textContent = existingContent + token.data;

          if (!codeBox.getAttribute("has-title")) {
            const titleDiv =
              codeBox.parentElement?.querySelector(".titlestyle");
            if (titleDiv) {
              titleDiv.textContent = token.data.split("\n")[0];
            }
            codeBox.setAttribute("has-title", "true");
          }
        }
      } else {
        var div = document.getElementById(`text-wrap-${currentInputVar}`);
        if (div) {
          if (token.data.startsWith("{'source': ")) {
            // Handle source tokens as before
            try {
              const sourceObj = JSON.parse(
                token.data.replace(/'/g, '"').replace(/None/g, "null")
              );
              if (sourceObj.source) {
                const sourceDiv = document.createElement("div");
                sourceDiv.classList.add("source-reference");
                sourceDiv.textContent = `Source: ${sourceObj.source}`;
                div.appendChild(sourceDiv);
              }
            } catch (error) {
              console.error("Error parsing source:", error);
            }
          } else {
            // Create or get the current paragraph container
            let currentParagraph = div.lastElementChild;
            if (
              !currentParagraph ||
              currentParagraph.classList.contains("parentcodeboxstyle") ||
              currentParagraph.classList.contains("source-reference") ||
              currentParagraph.classList.contains("image-container")
            ) {
              currentParagraph = document.createElement("div");
              currentParagraph.classList.add(
                "markdown-paragraph",
                styles.chatMarkdown
              );
              div.appendChild(currentParagraph);
            }

            // Update content
            const existingContent =
              currentParagraph.getAttribute("data-content") || "";
            const newContent = existingContent + token.data;
            currentParagraph.setAttribute("data-content", newContent);

            // Render markdown
            ReactDOM.render(
              <ReactMarkdown
                remarkPlugins={[remarkMath, remarkGfm]}
                rehypePlugins={[rehypeMathJax]}
              >
                {newContent}
              </ReactMarkdown>,
              currentParagraph
            );
          }
        }
      }

      setMessageList((prevMessageList) => [
        ...prevMessageList,
        responseMessage,
      ]);
    });

    return () => {
      socket.off("token");
      socket.close();
    };
  }, [clientId, selectedRoomId]);

  const showHide = (val: any) => {
    var codess = document.getElementById(`parent-code-div-${val}`);
    if (codess) {
      codess.style.display = codess.style.display === "none" ? "block" : "none";
    }
  };

  useEffect(() => {
    if (loading === false) {
      var generatedcode = document.getElementById(
        `code-generating-button-div-${lastgeneratingcode}`
      );
      if (generatedcode) {
        generatedcode.onclick = function () {
          showHide(generatedcode?.getAttribute("number"));
        };
      }
    }
  }, [loading]);

  //Send Question
  const fetchData = () => {
    setResponseStarted(true);
    setIsScrolledUp(false);
    if (inputMessage.trim() === "") return;

    setLoading(true);

    currentInputVar = messageList.length;

    const newInputMessage: Message = {
      type: "input",
      message: (
        <>
          <div className="flex justify-center mb-5">
            <div className="pb-2 max-w-3xl md:ml-10 max-sm:ml-6 w-full flex flex-row md:gap-6 max-sm:gap-4 items-center">
              <div className="h-full">
                {userData?.data?.profile_picture ? (
                  <img
                    className="rounded-full w-[40px] h-[40px] object-cover"
                    loading="lazy"
                    src={`data:image/jpg;base64,${userData?.data?.profile_picture}`}
                    alt={user_name}
                    style={{ width: 35, height: 35 }}
                  />
                ) : (
                  <img
                    src={ChatUser}
                    style={{ width: 35, height: 35 }}
                    alt={user_name}
                    loading="lazy"
                  />
                )}
              </div>
              <div className=" flex flex-col gap-2 mt-1 w-full">
                <p className=" text-black">{user_name}:</p>
                {selectedImage && (
                  <div className="rounded-md max-sm:pr-4 ">
                    <img
                      src={selectedImage}
                      alt="img"
                      loading="lazy"
                      className=" rounded-md max-h-[400px] "
                    />
                  </div>
                )}
                {inputMessage}
              </div>
            </div>
          </div>
        </>
      ),
    };

    setMessageList((prevMessageList) => [...prevMessageList, newInputMessage]);
    setInputMessage("");
    setPreviousQuestion(inputMessage);
    setSelectedImage(null);

    const formData = new FormData();
    formData.append("message", inputMessage);
    formData.append("type", "main");
    formData.append("user_id", clientId || "");
    formData.append("room_id", selectedRoomId.toString());
    if (selectedAgentId) {
      formData.append("agent_id", selectedAgentId);
    }
    if (selectedTag) {
      formData.append("tag_id", selectedTag);
    }
    if (selectedImage) {
      formData.append("image", selectedImage);
    }
    if (file) {
      formData.append("excel", file);
    }
    formData.append("use_tts", useTTs.toString());

    api
      .post(`${process.env.REACT_APP_ANSWERS}`, formData)
      .then((response) => {
        const audioId = uuidv4();
        if (response.data.audio) {
          const audioSrc = `data:audio/wav;base64,${response.data.audio}`;
          const audio = new Audio(audioSrc);
          setAudioElements((prev) => ({ ...prev, [audioId]: audio }));
        }
        const audioSrc = response?.data?.audio;
        const responseMessage: Message = {
          type: "response",
          message: response.data.text,
          audioId: audioId,
        };
        const audioMessage: Message = {
          type: "audio",
          message: response?.data?.audio,
        };
        setMessageList((prevMessageList) => {
          const newMessages = [...prevMessageList, responseMessage];
          if (audioSrc) {
            newMessages.push(audioMessage);
          }
          return newMessages;
        });

        setLoading(false);

        var imageRotate = document.getElementById(`logo-${currentInputVar}`);

        if (imageRotate === null) {
        } else {
          imageRotate.className = "";
        }
      })
      .catch((error) => {
        console.error("An error occurred:", error);
        setLoading(false);

        var imageRotate = document.getElementById(`logo-${currentInputVar}`);

        if (imageRotate === null) {
        } else {
          imageRotate.className = "";
        }

        var currentdiv = document.getElementById(
          `text-wrap-${currentInputVar}`
        );

        const res = document.createElement("span");
        res.classList.add("errorbox");
        res.innerHTML = error.response.data.message;
        // const btn = document.createElement("div");
        // btn.addEventListener("click", () => handleRegenrate());
        // btn.innerHTML = "Regenerate";
        // res.appendChild(btn);
        currentdiv?.appendChild(res);
      });

    setPreviousQuestion(inputMessage);
  };

  //Copy To Clipboard
  const copyToClipboard = (index: number) => {
    var div = document.getElementById(`copyToClipboard-${index}`);
    if (div === null) {
    } else {
      ReactDOM.render(<HiMiniClipboardDocumentCheck size={25} />, div);
    }

    let finalClip = "";
    messageList.map((item, i) =>
      index < i
        ? item.type === "response"
          ? (finalClip = finalClip + item.message)
          : (index = 10000000000)
        : null
    );

    finalClip = finalClip.replace(/start_code/g, "").replace(/end_code/g, "");

    const unsecuredCopyToClipboard = (text: string) => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
      document.body.removeChild(textArea);
    };

    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
        .writeText(finalClip)
        .then(() => {
          toast.success("Copied to clipboard!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            theme: "dark",
          });
          setTimeout(() => {
            ReactDOM.render(<AiOutlineCopy size={18} />, div);
          }, 2000);
        })
        .catch((error) => {
          console.error("Failed to copy text to clipboard: ", error);
        });
    } else {
      unsecuredCopyToClipboard(finalClip);
      toast.success("Copied to clipboard!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    }
  };

  const copyToClipboardHistory = (index: number) => {
    var div = document.getElementById(`copyToClipboard-history-${index}`);
    if (div === null) {
    } else {
      ReactDOM.render(<HiMiniClipboardDocumentCheck size={25} />, div);
    }
    let finalClip = "";
    finalClip = historyData[index].answer;
    finalClip = finalClip.replace(/start_code/g, "").replace(/end_code/g, "");
    const unsecuredCopyToClipboard = (text: string) => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
      document.body.removeChild(textArea);
    };
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(finalClip).then(() => {
        setTimeout(() => {
          ReactDOM.render(<AiOutlineCopy size={18} />, div);
        }, 2000);
      });
    } else {
      unsecuredCopyToClipboard(finalClip);
    }
    toast.success("Copied to clipboard!", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      theme: "dark",
    });
  };

  //Scroll To Bottom
  const scrollToBottom = () => {
    if (!isScrolledUp) {
      const div = document.getElementById("div-of-scroll");
      if (div === null) {
      } else {
        div.scrollTo({
          top: div.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    scrollToBottom();
    const handleScroll = () => {
      const div = chatContainerRef.current;

      setIsScrolledUp(true);
      if (div && div.scrollTop + div.clientHeight > div.scrollHeight - 5) {
        setIsScrolledUp(false);
      }
    };

    const div = chatContainerRef.current;
    if (div) {
      div.addEventListener("scroll", handleScroll);

      return () => {
        div.removeEventListener("scroll", handleScroll);
      };
    }
  }, [messageList, historyData]);

  //Like Dislike
  const handleLike = (index: number) => {
    var likeDiv = document.getElementById(`like-${index}`);
    if (likeDiv === null) {
    } else {
      ReactDOM.render(<AiFillLike size={25} />, likeDiv);
    }

    var disLikeDiv = document.getElementById(`disLike-${index}`);
    if (disLikeDiv === null) {
    } else {
      ReactDOM.render(<AiOutlineDislike size={25} />, disLikeDiv);
    }
  };
  const handleDisLike = (index: number) => {
    var likeDiv = document.getElementById(`like-${index}`);
    if (likeDiv === null) {
    } else {
      ReactDOM.render(<AiOutlineLike size={25} />, likeDiv);
    }
    var disLikeDiv = document.getElementById(`disLike-${index}`);
    if (disLikeDiv === null) {
    } else {
      ReactDOM.render(<AiFillDislike size={25} />, disLikeDiv);
    }
  };

  const handleLikeHistory = (index: number) => {
    var likeDiv = document.getElementById(`like-history-${index}`);
    if (likeDiv === null) {
    } else {
      ReactDOM.render(<AiFillLike size={25} />, likeDiv);
    }

    var disLikeDiv = document.getElementById(`disLike-history-${index}`);
    if (disLikeDiv === null) {
    } else {
      ReactDOM.render(<AiOutlineDislike size={25} />, disLikeDiv);
    }
  };
  const handleDisLikeHistory = (index: number) => {
    var likeDiv = document.getElementById(`like-history-${index}`);
    if (likeDiv === null) {
    } else {
      ReactDOM.render(<AiOutlineLike size={25} />, likeDiv);
    }
    var disLikeDiv = document.getElementById(`disLike-history-${index}`);
    if (disLikeDiv === null) {
    } else {
      ReactDOM.render(<AiFillDislike size={25} />, disLikeDiv);
    }
  };

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_INTERFACE_HISTORY}${selectedRoomId}`;

    api
      .get(apiUrl)
      .then((response) => {
        const data = response.data;
        setHistoryData(data);
        setInputMessage("");
        setUseTTs(false);
        currentInputVar = response.data.length - 1;
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [selectedRoomId]);

  const copyButtonHistory = (codeInputVar: number, inputVar: number) => {
    let codeContent = document.getElementById(`code-content-${codeInputVar}`);
    if (!codeContent) {
      codeContent = document.getElementById(
        `generate-code-content-${codeInputVar}`
      );
    }

    if (codeContent && codeContent.textContent) {
      const textToCopy = codeContent.textContent
        .split("\n")
        .slice(1)
        .join("\n")
        .trim();
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          const copyButton =
            document.querySelector(
              `#parent-code-div-${codeInputVar} .copy-button`
            ) ||
            document.querySelector(
              `#parent-generate-code-div-${codeInputVar} .copy-button`
            );

          if (copyButton instanceof HTMLButtonElement) {
            const originalText = copyButton.textContent;
            copyButton.textContent = "Copied!";
            setTimeout(() => {
              copyButton.textContent = originalText;
            }, 2000);
          }
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          alert("Failed to copy code to clipboard");
        });
    }
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setMoreOptions(false);
  };

  const toggleMoreOptionsButton = () => {
    setMoreOptions((prevMoreOptions) => !prevMoreOptions);
  };

  const handleStopGeneration = async () => {
    try {
      api.post(`${process.env.REACT_APP_STOP_GENERATION}${selectedRoomId}`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      var imageRotate = document.getElementById(`logo-${currentInputVar}`);

      if (imageRotate === null) {
      } else {
        imageRotate.className = "";
      }
    } catch (error) {}

    printcode = false;
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setSelectedImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const source = userData?.roles?.includes("employee")
      ? employeeExamples
      : examples;
    const shuffledArray = [...source].sort(() => Math.random() - 0.5);
    const subset = shuffledArray.slice(0, 6);
    setShuffledExamples(subset);
  }, [userData?.roles]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % Thinking.length);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [messageIndex]);

  const openDeleteAllButton = () => {
    setOpenDeleteAll(true);
  };

  const closeDeleteAllButton = () => {
    setOpenDeleteAll(false);
  };

  const handleDeleteButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeDeleteAllButton();
    }
  };

  return (
    <section className="flex flex-row bg-white w-full h-full text-zinc-500">
      {/* Sidebar */}
      <aside
        className={` relative ${
          sidebarVisible ? "lg:w-[18%] w-screen p-4" : "w-[0]"
        } h-full bg-[#000024] transition-all border-r-[1px] `}
      >
        <div className=" flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                setHistoryData([]);
                setMessageList([]);
                setSelectedAgent("");
                setSelectedAgentId("");
                setSelectedTag("");
                setSelectedTagName("");
                setInputMessage("");
                setSelectedRoomId(Math.round(Math.random() * 1e9));
                setFile(null);
                setUseTTs(false);
                newChatRefresh++;
              }}
              type="button"
              className={`w-full lg:h-[30px] h-[40px] rounded-md bg-[#20144C] text-white hover:bg-[#45328b] duration-300 ${
                sidebarVisible ? "" : "hidden"
              }`}
            >
              + New Chat
            </button>
            <div className={`relative ${sidebarVisible ? "" : " p-4"}`}>
              <button
                type="button"
                onClick={toggleSidebar}
                className={`lg:h-[30px] h-[40px] px-2 hover:bg-[#45328b] text-white duration-300 rounded-md ${
                  sidebarVisible ? " bg-[#20144C] text-white " : "bg-[#20144C]"
                }`}
              >
                <FiSidebar size={20} />
              </button>
            </div>
          </div>
        </div>
        <div
          onClick={handleButtonClick}
          className="h-screen mt-5 overflow-y-scroll custom-scrollbar-chat"
          style={{ maxHeight: "calc(100vh - 280px)" }}
        >
          {/* Chat history */}
          <ChatHistory
            setSelectedRoomId={setSelectedRoomId}
            selectedRoomId={selectedRoomId}
            setMessageList={setMessageList}
            setHistoryMainData={setHistoryData}
            messageList={messageList}
            loading={loading}
            toggleSidebar={toggleSidebar}
            refreshRooms={refreshRooms}
            setFile={setFile}
            setUseTTs={setUseTTs}
          />
        </div>

        <div
          className={`pt-6 border-t mt-5 border-[#C5D4EB] flex flex-row items-center justify-between ${
            sidebarVisible ? "" : "hidden"
          }`}
        >
          <div>
            <a href="https://boxmind.ai/" target="_blank" rel="noreferrer">
              <img
                src={Okation}
                width={120}
                height={40}
                alt="OkationAi"
                loading="lazy"
              />
            </a>
          </div>
          <div>
            <button
              onClick={toggleMoreOptionsButton}
              className=" hover:bg-[#45328b] text-white duration-300 p-3 rounded-lg mr-1"
            >
              <BsThreeDots />
            </button>
          </div>
        </div>
        {/* Start More Options */}
        {moreOptions && (
          <div className="z-50 absolute bottom-[110px] w-full pr-8 ">
            <div className="bg-[#061118] rounded-lg shadow-2xl ">
              <div className=" flex flex-col ">
                <p className="p-4 flex justify-center font-bold">
                  More Options
                </p>
                <div className=" border-b" />
                <div className="p-4 flex flex-col gap-3">
                  <button
                    onClick={openDeleteAllButton}
                    className=" bg-red-800 rounded-md text-white p-2 hover:bg-red-900 duration-300 w-full"
                  >
                    Delete All Rooms
                  </button>
                  {userData.tts_model === true && (
                    <button
                      onClick={toggleTTS}
                      className="p-2 rounded bg-gray-200 hover:bg-gray-300 duration-300 w-full"
                      title={
                        useTTs
                          ? "Turn off text-to-speech"
                          : "Turn on text-to-speech"
                      }
                    >
                      {useTTs ? (
                        <div className=" flex flex-row gap-2 items-center justify-center">
                          <p>Turn OFF TTS</p>
                          <MdVolumeUp size={24} className="text-blue-500" />
                        </div>
                      ) : (
                        <div className=" flex flex-row gap-2 items-center justify-center">
                          <p>Turn ON TTS</p>
                          <MdVolumeOff size={24} className="text-gray-500" />
                        </div>
                      )}
                    </button>
                  )}

                  {/* <button
                    disabled={messageList.length > 0 || historyData.length > 0}
                    onClick={showAgent}
                    className={` bg-[#EDEAF8] rounded-md p-2 w-full ${
                      messageList.length > 0 || historyData.length > 0
                        ? ""
                        : "hover:bg-[#b5b1c4] duration-300"
                    }`}
                  >
                    {selectedAgent === ""
                      ? "No Agent"
                      : selectedAgent + " Agent"}
                  </button>

                  <button
                    onClick={showTag}
                    className="bg-[#EDEAF8] rounded-md p-2 w-full hover:bg-[#b5b1c4] duration-300"
                  >
                    {selectedTagName === ""
                      ? "No Tag"
                      : selectedTagName + " Tag"}
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* End More Options */}
      </aside>

      {/* Main Chat */}
      <div
        onClick={handleButtonClick}
        className={`${sidebarVisible ? "w-[87%] max-lg:hidden" : "w-[100%]"}`}
      >
        {/* Response Section */}
        {historyData?.length > 0 ? (
          <>
            <div
              className={`flex justify-center gap-5 items-center lg:justify-start px-4 py-2 ${
                sidebarVisible ? "" : " lg:ml-[100px]"
              } `}
            >
              <Link to={"/"}>
                <img
                  src={Turbo}
                  width={130}
                  alt="boxMind"
                  loading="lazy"
                  title="Go back to Home Page"
                />
              </Link>
            </div>
            <div className="flex justify-center h-[85%]">
              <div
                ref={chatContainerRef}
                className="w-full h-[90%] overflow-y-scroll custom-scrollbar pt-8"
                id="div-of-scroll"
              >
                {historyData?.map((data, index) => (
                  <div key={index}>
                    <div className="flex justify-center mb-5">
                      <div className="pb-2 max-w-3xl lg:ml-10 max-sm:ml-6 w-full flex flex-row lg:gap-6 max-sm:gap-4 items-center">
                        <div className="h-full">
                          {userData?.data?.profile_picture ? (
                            <AsyncImage
                              className="rounded-full w-[40px] h-[40px] object-cover"
                              loading="lazy"
                              src={`data:image/jpg;base64,${userData?.data?.profile_picture}`}
                              alt={user_name}
                              style={{ width: 35, height: 35 }}
                              Transition={Blur}
                            />
                          ) : (
                            <AsyncImage
                              src={ChatUser}
                              loading="lazy"
                              style={{ width: 35, height: 35 }}
                              Transition={Blur}
                              alt={user_name}
                            />
                          )}
                        </div>
                        <div className=" flex flex-col gap-2 mt-1 w-full">
                          <p className=" text-black">{user_name}:</p>
                          {data?.image && (
                            <div
                              onClick={() => handleImageClick(data?.image)}
                              className="rounded-md max-sm:pr-4"
                            >
                              <img
                                src={data?.image}
                                alt="img"
                                loading="lazy"
                                className="rounded-md max-h-[400px] "
                              />
                            </div>
                          )}
                          <p>{data?.question}</p>
                        </div>
                      </div>
                      {expandedImage && data?.image && (
                        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-30 flex justify-center items-center z-40">
                          <div>
                            <img
                              src={expandedImage}
                              alt="Expanded img"
                              className="max-w-full max-h-full"
                            />
                          </div>
                          <div className=" fixed top-4 right-4 z-50">
                            <button onClick={() => handleCloseModal()}>
                              <AiOutlineClose
                                size={35}
                                className=" text-white"
                              />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-center mb-5">
                      <div
                        className={`pb-7 max-w-3xl lg:ml-10 max-sm:ml-6 w-full flex flex-row lg:gap-6 max-sm:gap-4 items-center`}
                      >
                        <div className=" h-full">
                          <img
                            src={Logo}
                            alt="TurboMind"
                            loading="lazy"
                            width={35}
                            height={35}
                            className=""
                          />
                        </div>
                        <div className=" flex flex-col gap-2 mt-1 w-full">
                          <p className=" text-black">boxMind:</p>
                          <div>
                            {data.answer
                              ?.split("start_code")
                              .map((part, partIndex) => {
                                if (partIndex === 0) {
                                  return (
                                    <React.Fragment key={partIndex}>
                                      <div
                                        className={`${styles.chatMarkdown} markdown-paragraph`}
                                      >
                                        <ReactMarkdown
                                          remarkPlugins={[
                                            remarkMath,
                                            remarkGfm,
                                          ]}
                                          rehypePlugins={[rehypeMathJax]}
                                        >
                                          {part}
                                        </ReactMarkdown>
                                      </div>
                                    </React.Fragment>
                                  );
                                } else {
                                  const [content, rest] =
                                    part?.split("end_code");
                                  const language = content
                                    .split("\n")[0]
                                    .trim();
                                  return (
                                    <React.Fragment key={partIndex}>
                                      <div
                                        key={partIndex}
                                        className={`parentcodeboxstylehistory `}
                                      >
                                        <div key={0} className="titlestyle">
                                          <span>{language}</span>{" "}
                                          <button
                                            className="copy-button"
                                            id={`copy-button-${partIndex}-${index}`}
                                            onClick={() => {
                                              const codeContent =
                                                document.getElementById(
                                                  `code-div-history-${partIndex}-${index}`
                                                )?.textContent;
                                              if (codeContent) {
                                                navigator.clipboard
                                                  .writeText(codeContent.trim())
                                                  .then(() => {
                                                    const button =
                                                      document.getElementById(
                                                        `copy-button-${partIndex}-${index}`
                                                      );
                                                    if (button) {
                                                      const originalText =
                                                        button.textContent;
                                                      button.textContent =
                                                        "Copied!";
                                                      setTimeout(() => {
                                                        button.textContent =
                                                          originalText;
                                                      }, 2000);
                                                    }
                                                  })
                                                  .catch((err) => {
                                                    console.error(
                                                      "Failed to copy text: ",
                                                      err
                                                    );
                                                    alert(
                                                      "Failed to copy code to clipboard"
                                                    );
                                                  });
                                              }
                                            }}
                                          >
                                            Copy
                                          </button>
                                        </div>
                                        <div className="overflow-x-scroll w-full">
                                          <SyntaxHighlighter
                                            language={language}
                                            style={dracula}
                                            className="codeboxstyle "
                                            id={`code-div-history-${partIndex}-${index}`}
                                          >
                                            {content
                                              ?.split("\n")
                                              .map((cont, ind) => {
                                                if (ind === 0) {
                                                  return "";
                                                } else if (ind === 1) {
                                                  return cont;
                                                } else {
                                                  return "\n" + cont;
                                                }
                                              })
                                              .join("")}
                                          </SyntaxHighlighter>
                                        </div>
                                      </div>
                                      <div
                                        className={`${styles.chatMarkdown} markdown-paragraph`}
                                      >
                                        <ReactMarkdown
                                          remarkPlugins={[
                                            remarkMath,
                                            remarkGfm,
                                          ]}
                                          rehypePlugins={[rehypeMathJax]}
                                        >
                                          {rest}
                                        </ReactMarkdown>
                                      </div>
                                    </React.Fragment>
                                  );
                                }
                              })}
                          </div>

                          {loading && currentInputVar === index ? null : (
                            <div className={`h-full mt-2 max-sm:pr-4`}>
                              <button
                                type="button"
                                onClick={() => copyToClipboardHistory(index)}
                                className="-mt-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                id={`copyToClipboard-history-${index}`}
                              >
                                <AiOutlineCopy size={18} />
                              </button>
                              {/* <button
                                type="button"
                                onClick={() => handleLikeHistory(index)}
                                className="ml-2 mb-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                id={`like-history-${index}`}
                              >
                                <AiOutlineLike size={18} />
                              </button>
                              <button
                                type="button"
                                onClick={() => handleDisLikeHistory(index)}
                                className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                id={`disLike-history-${index}`}
                              >
                                <AiOutlineDislike size={18} />
                              </button> */}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <>
                  {messageList?.map((item, i) =>
                    item.type === "input" ? (
                      <div key={i}>
                        {item?.message}
                        <div className="flex justify-center mb-5">
                          <div className="pb-2 max-w-3xl md:ml-10 max-sm:ml-6 w-full flex flex-row md:gap-6 max-sm:gap-4 items-center">
                            <div className="h-full">
                              <img
                                src={Logo}
                                alt="TurboMind"
                                width={35}
                                loading="lazy"
                                height={35}
                                className=" animate-spin"
                                id={`logo-${i}`}
                              />
                            </div>
                            <div className="  flex flex-col gap-2 mt-1 w-full">
                              <p className=" text-black">boxMind:</p>
                              {useTTs === true ? (
                                <div id={`text-wrap-${i}`}>
                                  {messageList[i + 1] &&
                                    messageList[i + 1].type === "response" && (
                                      <div className="whitespace-break-spaces">
                                        {messageList[i + 1]?.audioId &&
                                          audioElements[
                                            messageList[i + 1]?.audioId ?? ""
                                          ] && (
                                            <div>
                                              <ReactAudioPlayer
                                                src={
                                                  audioElements[
                                                    messageList[i + 1]
                                                      ?.audioId ?? ""
                                                  ].src
                                                }
                                                autoPlay={true}
                                                controls
                                              />
                                            </div>
                                          )}
                                        <ReactMarkdown
                                          remarkPlugins={[
                                            remarkMath,
                                            remarkGfm,
                                          ]}
                                          rehypePlugins={[rehypeMathJax]}
                                        >
                                          {messageList[i + 1].message as string}
                                        </ReactMarkdown>
                                      </div>
                                    )}
                                </div>
                              ) : (
                                <p id={`text-wrap-${i}`}></p>
                              )}
                              {loading && currentInputVar === i ? null : (
                                <div className={`h-full mt-2 max-sm:pr-4`}>
                                  <button
                                    type="button"
                                    onClick={() => copyToClipboard(i)}
                                    className="-mt-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`copyToClipboard-${i}`}
                                  >
                                    <AiOutlineCopy size={18} />
                                  </button>
                                  {/* <button
                                    type="button"
                                    onClick={() => handleLike(i)}
                                    className="ml-2 mb-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`like-${i}`}
                                  >
                                    <AiOutlineLike size={18} />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleDisLike(i)}
                                    className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`disLike-${i}`}
                                  >
                                    <AiOutlineDislike size={18} />
                                  </button> */}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null
                  )}
                </>
              </div>
            </div>
          </>
        ) : messageList?.length > 0 ? (
          <>
            <div
              className={`flex justify-center gap-5 items-center lg:justify-start px-4 py-2 ${
                sidebarVisible ? "" : " lg:ml-[100px]"
              } `}
            >
              <Link to={"/"}>
                <img
                  src={Turbo}
                  width={130}
                  alt="boxMind"
                  loading="lazy"
                  title="Go back to Home Page"
                />
              </Link>
            </div>
            <div className=" flex justify-center h-[85%]">
              <div
                ref={chatContainerRef}
                className="w-full h-[90%] overflow-y-scroll custom-scrollbar pt-8"
                id="div-of-scroll"
              >
                {messageList?.map((item, i) =>
                  item.type === "input" ? (
                    <div key={i}>
                      {item.message}
                      <div className="flex justify-center mb-5">
                        <div className="pb-7 max-w-3xl md:ml-10 max-sm:ml-6 w-full flex flex-row md:gap-6 max-sm:gap-4 items-center">
                          <div className="h-full">
                            <img
                              src={Logo}
                              loading="lazy"
                              alt="TurboMind"
                              width={35}
                              height={35}
                              className=" animate-spin"
                              id={`logo-${i}`}
                            />
                          </div>
                          <div className="  flex flex-col gap-2 mt-1 w-full">
                            <p className=" text-black">boxMind:</p>
                            {useTTs === true ? (
                              <div
                                id={`text-wrap-${i}`}
                                className="whitespace-break-spaces"
                              >
                                {messageList[i + 1] &&
                                  messageList[i + 1].type === "response" && (
                                    <div>
                                      {messageList[i + 1]?.audioId &&
                                        audioElements[
                                          messageList[i + 1]?.audioId ?? ""
                                        ] && (
                                          <div>
                                            <ReactAudioPlayer
                                              src={
                                                audioElements[
                                                  messageList[i + 1]?.audioId ??
                                                    ""
                                                ].src
                                              }
                                              autoPlay={true}
                                              controls
                                            />
                                          </div>
                                        )}
                                      <ReactMarkdown
                                        remarkPlugins={[remarkMath, remarkGfm]}
                                        rehypePlugins={[rehypeMathJax]}
                                      >
                                        {messageList[i + 1].message as string}
                                      </ReactMarkdown>
                                    </div>
                                  )}
                              </div>
                            ) : (
                              <p id={`text-wrap-${i}`}></p>
                            )}
                            {loading && currentInputVar === i ? null : (
                              <div className={`h-full mt-2 max-sm:pr-4`}>
                                <button
                                  type="button"
                                  onClick={() => copyToClipboard(i)}
                                  className="-mt-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                  id={`copyToClipboard-${i}`}
                                >
                                  <AiOutlineCopy size={18} />
                                </button>
                                {/* <button
                                  type="button"
                                  onClick={() => handleLike(i)}
                                  className="ml-2 mb-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                  id={`like-${i}`}
                                >
                                  <AiOutlineLike size={18} />
                                </button>
                                  <button
                                    type="button"
                                    onClick={() => handleDisLike(i)}
                                    className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`disLike-${i}`}
                                  >
                                    <AiOutlineDislike size={18} />
                                  </button> */}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </>
        ) : (
          // Response Active
          // Response Inactive
          <div className=" flex justify-center mx-auto content-center lg:pt-10 pt-2">
            <div className="h-[85%] flex flex-col gap-20 justify-center items-center">
              <div className=" flex justify-center items-center">
                <img
                  src={Turbo}
                  width={280}
                  height={50}
                  loading="lazy"
                  alt="TurboMind"
                  className=" max-md:w-[250px]"
                />
              </div>
              <div className="flex flex-col max-lg:px-4">
                <AnimatePresence>
                  <motion.div
                    initial={{ opacity: 0, y: 4 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -1 }}
                    viewport={{ once: false }}
                    transition={{ duration: 0.3 }}
                    className="grid justify-center grid-cols-2 gap-5"
                  >
                    {shuffledExamples?.map((item, index) => (
                      <div
                        key={index}
                        className="mt-4 p-4 bg-[#EDEAF8] rounded-md cursor-pointer max-w-[1740px] max-md:text-[12px] text-center hover:bg-[#b5b1c4] duration-300"
                        onClick={() => {
                          setInputMessage(item);
                          inputRef.current?.focus();
                        }}
                      >
                        {item}
                      </div>
                    ))}
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Input Section */}
      <div
        className={` ${sidebarVisible && "md:ml-[145px] max-lg:hidden"} ${
          sideActive && "max-lg:hidden"
        } ${
          mainSidebarOpen && window.innerWidth > 1024 && "ml-[140px]"
        } fixed left-1/2 -translate-x-1/2 bottom-2 md:w-[43rem] w-full max-md:px-4 flex flex-col duration-300 `}
      >
        {/* Images Start */}

        {selectedImage && (
          <div className="flex bg-white rounded-md p-4">
            <div className="relative">
              <img
                src={selectedImage}
                loading="lazy"
                alt={`Selected pic`}
                className="w-[60px] h-[60px] rounded-md object-cover"
              />
              <button
                className="absolute top-1 right-1 p-1 bg-red-600 hover:bg-red-700 duration-300 text-white rounded-full"
                onClick={handleRemoveImage}
              >
                <MdOutlineCancel size={10} />
              </button>
            </div>
          </div>
        )}
        {/* Images End */}
        <div className=" flex flex-row gap-2 ">
          <div className=" w-full flex flex-row items-center bg-white rounded-2xl border border-gray-300">
            {/* Upload Image Start */}
            {/* <div>
              <label htmlFor="imageInput" className="cursor-pointer">
                <input
                  type="file"
                  id="imageInput"
                  accept=".png, .jpg, .jpeg"
                  className="hidden"
                  multiple={false}
                  onChange={handleImageChange}
                />
                <div className=" pl-4 rounded-md cursor-pointer">
                  <GoImage size={20} />
                </div>
              </label>
            </div> */}
            {/* Upload Image End */}
            {userData?.sst_model === true && (
              <button
                onClick={handleRecording}
                className="ml-2 p-2 rounded bg-gray-200 hover:bg-gray-300 duration-300"
              >
                {isRecording ? (
                  <CiStop1 size={24} className="text-red-500" />
                ) : (
                  <RiMicLine size={24} className="text-blue-500" />
                )}
              </button>
            )}
            <textarea
              autoFocus
              ref={inputRef}
              value={inputMessage}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !loading && !e.shiftKey) {
                  fetchData();
                  e.preventDefault();
                }
              }}
              onChange={(e) => setInputMessage(e.target.value)}
              className={`w-full mx-auto  pr-16 bg-white outline-none p-4 resize-none rounded-2xl ${
                inputMessage.length <= 134
                  ? "h-[55px] custom-scrollbar"
                  : "h-[140px] custom-scrollbar-chat"
              }`}
              placeholder="Send a message"
              maxLength={1000}
            />
            {loading ? (
              <div className=" flex justify-end py-3">
                <div
                  onClick={handleStopGeneration}
                  className=" bg-[#EDEAF8] border-[#EDEAF8] p-1 rounded-md hover:bg-[#b5b1c4] duration-300 cursor-pointer mr-3"
                >
                  <CiStop1 size={20} />
                </div>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => fetchData()}
                disabled={loading || inputMessage.length === 0}
                className={` mr-3  ${
                  inputMessage.length !== 0
                    ? "bg-[#135991] text-white p-1 rounded-md"
                    : "p-1"
                } ${loading ? " bg-[#163752] rounded-md" : ""}`}
              >
                <VscSend size={20} />
              </button>
            )}
          </div>
        </div>
        <div>
          <span
            className={`flex justify-end  ${
              inputMessage.length === 1000 ? "text-[red]" : "text-gray-500"
            }`}
          >
            {inputMessage.length}/1000
          </span>
        </div>
      </div>

      {openDeleteAll && (
        <DeleteAllRooms
          handleDeleteButtonClick={handleDeleteButtonClick}
          clientId={clientId}
          setSelectedRoomId={setSelectedRoomId}
          setMessageList={setMessageList}
          setHistoryData={setHistoryData}
          setRefreshRooms={setRefreshRooms}
          setOpenDeleteAll={setOpenDeleteAll}
          setUseTTs={setUseTTs}
          setMoreOptions={setMoreOptions}
          setFile={setFile}
        />
      )}
      {/* <Agent
        selectedAgent={selectedAgent}
        showAgent={showAgent}
        setSelectedAgent={setSelectedAgent}
        agentActive={agentActive}
        onSelectAgent={setSelectedAgent}
        setSelectedAgentId={setSelectedAgentId}
        setSelectedTagName={setSelectedTagName}
        setSelectedTag={setSelectedTag}
      ></Agent>

      <Tag
        selectedTag1={selectedTag}
        showTag={showTag}
        tagActive={tagActive}
        onSelectTag={setSelectedTag}
        selectedAgentId={selectedAgentId}
        setSelectedTagName={setSelectedTagName}
      ></Tag> */}
    </section>
  );
}

export default NewChat;
